





















import Vue from 'vue'
import { City, BusinessArea, Department } from '@/types'

export default Vue.extend({
  name: 'JobSearchPills',
  computed: {
    selectedCities () : City[] {
      return this.$store.state.selectedCities.map((c : string) : City => this.getCity(c))
    },
    selectedBusinessAreas () : BusinessArea[] {
      return this.$store.state.selectedBusinessAreas.map((a : string) : BusinessArea => this.getBusinessArea(a))
    },
    selectedDepartments () : Department[] {
      return this.$store.state.selectedDepartments.map((d : string) : Department => this.getDepartment(d))
    },
    selectedShifts () : string [] {
      return this.$store.state.selectedShifts
    }
  },
  methods: {
    getCity (id: string) : City {
      return this.$store.getters.getCity(id)
    },
    getBusinessArea (id : string) : BusinessArea {
      return this.$store.getters.getBusinessArea(id)
    },
    getDepartment (id: string) : Department {
      return this.$store.getters.getDepartment(id)
    },
    unselectCity (id : string) : void {
      this.$store.dispatch('unselectCity', id)
    },
    unselectBusinessArea (id : string) : void {
      this.$store.dispatch('unselectBusinessArea', id)
    },
    unselectDepartment (id : string) : void {
      this.$store.dispatch('unselectDepartment', id)
    },
    unselectShift (shift : string) : void {
      this.$store.dispatch('unselectShift', shift)
    }
  }
})
